<div class="w-full h-[60px] flex items-center select-dropdown justify-between bg-white pl-4 pr-4 cursor-pointer" (click)="selectItem()">
  <div class="absolute top-0 mt-0.5 placeholder text-sm">{{ placeholder | transloco }}</div>
  <div class="text-base" [class.disabled]="disabled">{{ selectedItem.title | transloco }}</div>
  <ion-icon name="chevron-down" class="text-2xl"></ion-icon>
</div>
